import { Box, Tooltip, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import OrdersCell from "../../../Components/OrdersCell";

const ActionsCell = ({
  params,
  setSelectedCustomer,
  setOpenDeleteCustomer,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        height: "100%",
        minHeight: "52px",
      }}
    >

      

      {params.row.allow_delete === 1 && (
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 8px",
          gap: 1,
        }}
      >
        
        <Tooltip title="Delete">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
            onClick={() => {
              setSelectedCustomer(params.row);
              setOpenDeleteCustomer(true);
            }}
          >
            <DeleteForeverIcon fontSize="small" color="error" />
            <Typography
              variant="body2"
              sx={(theme) => ({
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: theme.palette.error.main,
              })}
            >
              Delete
            </Typography>
          </Box>
          
        </Tooltip>
       
      </Box>
       )}
      {params.row?.orders && params.row?.orders?.length > 0 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginRight: "8px",
            }}
          >
            <OrdersCell data={params.row.orders} />
          </Box>
        </>
      )}
    </Box>
  );
};

export default ActionsCell;
